// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SimplePaperPodcast-cls1___9caa78c53ee7087deeb{/*!*/}.SimplePaperPodcast-cls2__eaa945110fb60dd1cb50{}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SimplePaperPodcast-cls1___9caa78c53ee7087deeb",
	"cls2": "SimplePaperPodcast-cls2__eaa945110fb60dd1cb50 SimplePaperPodcast-cls1___9caa78c53ee7087deeb"
};
export default ___CSS_LOADER_EXPORT___;
